;(function setInitialTheme() {
  try {
    const key = 'portfolio-theme'
    const saved = localStorage.getItem(key)
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    const theme =
      saved === 'light' || saved === 'dark'
        ? saved
        : prefersDark
          ? 'dark'
          : 'light'
    document.documentElement.setAttribute('data-theme', theme)
  } catch {
    document.documentElement.setAttribute('data-theme', 'dark')
  }
})()
